const TimerIcon = (props) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.69 600">
      <path
        d="M323.48,75.42V48.72h35.33a7.93,7.93,0,0,0,7.94-7.94V8A7.94,7.94,0,0,0,358.81,0H239.42a8,8,0,0,0-7.95,8V40.78a7.94,7.94,0,0,0,7.95,7.94h35.33V75.56C141.62,88.3,37.16,200.74,37.16,337.16,37.16,482.09,155.06,600,300,600S562.84,482.09,562.84,337.16C562.84,200.15,457.44,87.34,323.48,75.42ZM300,544.52c-114.33,0-207.35-93-207.35-207.36S185.66,129.8,300,129.8s207.37,93,207.37,207.36S414.34,544.52,300,544.52ZM476.74,337.16A176.86,176.86,0,0,1,410,475.46L300,337.16l-1.16-176.73H300C397,160.42,476.74,240.21,476.74,337.16Zm-8.09-222.31a8.78,8.78,0,0,1,0-12.42l22.56-22.56a8.78,8.78,0,0,1,12.42,0L558,134.26a8.77,8.77,0,0,1,0,12.41l-22.56,22.57a8.78,8.78,0,0,1-12.42,0Z"
        transform="translate(-37.16)"
      />
    </svg>
  );
};

export default TimerIcon;
